import { Injectable } from '@angular/core';
import { ConfigService } from './../../_services/config.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrationTripService {

  constructor(
    public configServ: ConfigService
  ) {}


  getTripInfo() {
    return this.configServ.configs.find(c => c.key === 'turcja2021').value;
  }

}